<template>
  <v-card flat>
    <v-card-title class="d-flex align-center pe-2">
      <!-- <v-icon icon="mdi-file" class="animate__animated animate__delay-1s animate__infinite animate__headShake"></v-icon> &nbsp; PERSONAL POLICIAL -->
      <v-icon icon="mdi-file"></v-icon> &nbsp; CIVILES
      <v-spacer></v-spacer>

      <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" density="compact" label="buscar" single-line flat
        hide-details variant="solo-filled"></v-text-field>
    </v-card-title>

    <v-divider></v-divider>
    <v-data-table 
    :items="personalCivilList"
    v-model:search="search" 
    :loading="loading" 
    :headers="headers">

      <!-- ... Resto del código de la plantilla ... -->
      <!-- Puedes mantener las mismas plantillas de encabezado e imágenes -->
      <!-- ... -->

      <!-- Agrega la ranura 'item' para personalizar cada fila -->
      <template v-slot:item="{ item }">
        <tr>
          <!-- Puedes mantener las demás celdas de la fila -->
          <td>{{ item.grado }}</td>
          <td>{{ item.primer_nombre }}</td>
          <td>{{ item.segundo_nombre }}</td>
          <td>{{ item.primer_apellido }}</td>
          <td>{{ item.segundo_apellido }}</td>
          <td>{{ item.carnet }}</td>


          <!-- Agrega la celda para el botón de detalle -->

          <td>
            <v-btn dense color="blue darken-1" @click="editDetalle(item); editMode = true; dialog = true" class="mr-1"
              rounded>
              <v-icon left class="animate__animated animate__delay-2s animate__infinite animate__headShake">mdi-pencil</v-icon>
            </v-btn>

            <v-btn dense color="red darken-1" @click="deleteDetalle(item)" class="mr-2" rounded>
              <v-icon left class="animate__animated animate__delay-2s animate__infinite animate__headShake">mdi-delete-empty</v-icon>
            </v-btn>



          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="showModal" max-width="600">
      <v-card>
        <v-card-title class="custom-card-title">
          Detalles de los Civiles
        </v-card-title>


        <v-card-text>
          <v-container fluid>
            <v-row>
              <!-- <v-col cols="12" sm="6">
                <v-text-field v-model="detalleSeleccionado.id" label="ID" outlined dense></v-text-field>
              </v-col> -->
              <v-col cols="12" sm="6">
                <v-text-field v-model="detalleSeleccionado.grado" label="Grado" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="detalleSeleccionado.carnet" label="CI" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="detalleSeleccionado.primer_nombre" label="1er Nombre" outlined
                  dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="detalleSeleccionado.segundo_nombre" label="2do Nombre" outlined
                  dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="detalleSeleccionado.primer_apellido" label="Apellido Paterno" outlined
                  dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field v-model="detalleSeleccionado.segundo_apellido" label="Apellido Materno" outlined
                  dense></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions style="justify-content: center;">
          <v-btn class="custom-btn" color="blue darken-1" text @click="showModal = false">Cerrar</v-btn>
          <v-btn class="custom-btn" color="green darken-1" text @click="actualizarPersonalCivil">Guardar</v-btn>
        </v-card-actions>


      </v-card>
    </v-dialog>

  </v-card>

</template>
<script>
import Swal from 'sweetalert2'
import axios from 'axios';
import { defineComponent } from "vue";
//import PersonalPolicialService from "@/http/services/PersonalPolicialService";
import PersonalCivilService from "@/http/services/PersonalCivilService";
import ComplementariosService from "@/http/services/ComplementariosService";
import formEditar from "@/http/services/formEditar";
export default {
  data() {
    const personalService = new PersonalCivilService();
    return {
      dialog_delete: false,
      personalService,
      search: "",
      personalCivilList: [], // Aquí almacenaremos los datos del servicio
      Complementarios: [],
      showModal: false,
      detalleSeleccionado: {
          grado: "",
          genero: "",
          primer_nombre: "",
          segundo_nombre: "",
          primer_apellido: "",
          segundo_apellido: "",
          carnet: "",
          expedido: "",
        },
      headers: [
        {
          title: "GRADO",
          text: "",
          value: "grado",
        },
        {
          title: "1ER NOMBRE",
          text: "",
          value: "primer_nombre",
        },
        {
          title: "2DO NOMBRE",
          text: "",
          value: "segundo_nombre",
        },
        {
          title: "APELLIDO PATERNO",
          text: "",
          value: "primer_apellido",
        },
        {
          title: "APELLIDO MATERNO",
          text: "",
          value: "segundo_apellido",
        },
        {
          title: "CEDULA DE IDENTIDAD",
          text: "",
          value: "carnet",
        },
        {
          title: "ACCIONES",
          text: "",
          value: "",
        },
        // Agrega más columnas según tus necesidades
      ],
    };
  },
  created() {
    this.loadData();
  },
  /* mounted() {
        this.registros();
    }, */
  methods: {
    async loadData() {
      const personalService = new PersonalCivilService();

      try {
        const personalList = await personalService.index();
        this.personalCivilList = personalList;
      } catch (error) {
        console.error("Error al cargar datos:", error);
      }

    },
    async actualizarPersonalCivil() {
      try {
        // Llama al método updateForm del servicio con el ID y los datos actualizados
        const response = await this.personalService.updateForm(this.detalleSeleccionado.id, this.detalleSeleccionado);
        console.log("Respuesta del servidor:", response);

        // Aquí puedes mostrar un mensaje de éxito utilizando Swal o cualquier otro método
        Swal.fire({
          icon: 'success',
          title: 'Registro actualizado',
          text: 'El registro del civil ha sido actualizado correctamente.',
        });
        
        // También puedes realizar otras acciones después de actualizar, como recargar los datos o cerrar el modal
        // this.loadData(); // Recarga los datos
        // this.showModal = false; // Cierra el modal
      } catch (error) {
        
        console.error("Error al actualizar el registro:", error);

        // Aquí puedes mostrar un mensaje de error utilizando Swal o cualquier otro método
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Ha ocurrido un error al actualizar el registro. Por favor, inténtalo de nuevo más tarde.',
        });
      }
      this.cerrarModal();
    },
    editDetalle(item) {
      // Muestra el modal y establece el detalle seleccionado
      this.showModal = true;
      this.detalleSeleccionado = item;
    },
    cerrarModal() {
      this.showModal = false;
      this.detalleSeleccionado = {};
      this.loadData();
    },

    ///***********************************************************************************///     
    //*****************************PARA GUARDAR********************************************///
    //************************************************************************************///

    guardarDetalle() {
      if (this.validarDetalles()) {

        setTimeout(() => {
          // Una vez que la llamada asíncrona ha sido completada (simulada), puedes mostrar un mensaje de éxito o realizar otras acciones necesarias
          console.log('Detalles del estudiante guardados con éxito:', this.detalleSeleccionado);
          // Aquí podrías emitir un evento o realizar otras acciones necesarias después de guardar los detalles
        }, 1000); // Simulamos un tiempo de espera de 1 segundo (1000 milisegundos)
      } else {
        console.log('Error: Los detalles del estudiante no son válidos');
        // Aquí podrías mostrar un mensaje de error al usuario o realizar otras acciones en caso de que los detalles no sean válidos
      }
    },
    validarDetalles() {
      // Aquí podrías implementar la lógica para validar los detalles del estudiante
      // Por ejemplo, podrías verificar si todos los campos obligatorios están completos
      if (
        this.detalleSeleccionado.grado &&
        this.detalleSeleccionado.carnet &&
        this.detalleSeleccionado.primer_nombre &&
        this.detalleSeleccionado.primer_apellido
      ) {
        // Si todos los campos obligatorios están completos, devolvemos true
        return true;
      } else {
        // Si falta algún campo obligatorio, devolvemos false
        return false;
      }
    },


    //**********************************************************************************//
    //*****************************PARA ELIMINAR****************************************//
    //**********************************************************************************//    
    deleteDetalle(item) {
  console.log("Eliminar detalle:", item);
  if (item && typeof item.id !== "undefined") {
    // Ahora puedes acceder a item.id de forma segura
    this.index_array = this.personalCivilList.indexOf(item);
    this.item_reg_pol = item;
    // Muestra la alerta de confirmación
    Swal.fire({
      title: '¿Estás seguro?',
      text: "¡No podrás revertir esto!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminarlo!',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        // Si el usuario confirma, llama a deleteConfirm() para eliminar el elemento
        this.deleteConfirm();
      }
    });
  } else {
    console.error("El registro no tiene un ID válido.");
  }
},

    async deleteConfirm() {
      const personalService = new PersonalCivilService();
      console.log("ID a eliminar:", this.item_reg_pol.id);
      const response = await personalService.destroypolicia(
        this.item_reg_pol.id
      );
      console.log("Respuesta de la eliminación:", response);
      if (response.status) {
        this.snackbar_registers_enabled = true;
        this.snackbar_color = "cyan-darken-3";
        this.snackbar_registers_message = response.message;
        this.personalCivilList.splice(this.index_array, 1);
      } else {
        this.snackbar_registers_enabled = true;
        this.snackbar_color = "red";
        this.snackbar_registers_message = "Error interno del servidor";
      }

      this.closeDialogDelete();
    },
    closeDialogDelete() {
      this.dialog_delete = false;
      this.clear();
    },
    closeDialogForm() {
      this.dialog_form = false;
      this.dialog_edit_form = false;
      this.clear();
      this.registros();
    },
    clear() {
      this.$nextTick(() => {
        this.item_reg_pol = Object.assign({}, this.default_item);
        this.index_array = -1;
      });
      this.errors_validate = {};
    },
    /* deleteDetalle(item) {
      const personalService = new PersonalPolicialService();
      Swal.fire({
        title: '¿Estás seguro?', //+index+"? "
        text: '¡No podrás revertir esto!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminarlo!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.isConfirmed) {
          // Elimina el elemento de la lista en el índice especificado
          this.personalCivilList.splice(index, 1);
          // Muestra una alerta de éxito después de eliminar el registro
          Swal.fire(
            '¡Eliminado!',
            'Tu registro ha sido eliminado.',
            'success'
          );
        }
      });
    } */
  },
};
</script>


<!--*********************************************************************************************************-->
<!--************************************************ESTILOS**************************************************-->
<!--*********************************************************************************************************-->

<style>
.custom-card-title {
  text-align: center;
  background-color: #007bff;
  /* Color de fondo azul más formal */
  color: #fff;
  /* Texto blanco */
  padding: 10px;
  /* Espaciado interno */
  font-size: 24px;
  /* Tamaño de fuente */
  font-weight: bold;
  /* Negrita */
  border-radius: 5px;
  /* Bordes redondeados */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* Sombra */
}


.custom-btn {
  font-size: 16px;
  /* Tamaño de fuente */
  font-weight: bold;
  /* Negrita */
  padding: 10px 20px;
  /* Espaciado interno */
  margin: 0 10px;
  /* Espaciado externo */
  border-radius: 5px;
  /* Bordes redondeados */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  /* Sombra */
  transition: all 0.3s ease;
  /* Transición suave */
}

.custom-btn:hover {
  background-color: #e1e7ee;
  /* Color de fondo azul al pasar el mouse */
  color: #faf6f6;
  /* Texto blanco al pasar el mouse */
}
</style>@/http/services/PersonalCivilService